import dinero from 'dinero.js';

export function FromSmallestUnit(amount: number, currency: string) {
  return dinero({ amount, currency: currency as any }).toFormat();
}
